import { cn } from '@/lib/utils'

interface SpinnerProps {
  className?: string
  size?: 'sm' | 'md' | 'lg'
}

const sizeMap = {
  sm: 'w-4 h-4',
  md: 'w-10 h-10',
  lg: 'w-16 h-16',
}

export const Spinner = ({ className, size = 'md' }: SpinnerProps) => {
  return (
    <div
      className={cn(
        'spinner border-4 border-gray-200 border-t-4 border-t-blue-500 rounded-full animate-spin',
        sizeMap[size],
        className,
      )}
    />
  )
}
